/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1CheckIcon16Light } from './People1CheckIcon16Light';
import { People1CheckIcon16Regular } from './People1CheckIcon16Regular';
import { People1CheckIcon16Solid } from './People1CheckIcon16Solid';
import { People1CheckIcon20Light } from './People1CheckIcon20Light';
import { People1CheckIcon20Regular } from './People1CheckIcon20Regular';
import { People1CheckIcon20Solid } from './People1CheckIcon20Solid';
import { People1CheckIcon24Regular } from './People1CheckIcon24Regular';
import { People1CheckIcon24Solid } from './People1CheckIcon24Solid';
import { People1CheckIcon32Regular } from './People1CheckIcon32Regular';
import { People1CheckIcon64Regular } from './People1CheckIcon64Regular';
var sizes = {
    16: {
        light: People1CheckIcon16Light,
        regular: People1CheckIcon16Regular,
        solid: People1CheckIcon16Solid,
    },
    20: {
        light: People1CheckIcon20Light,
        regular: People1CheckIcon20Regular,
        solid: People1CheckIcon20Solid,
    },
    24: {
        regular: People1CheckIcon24Regular,
        solid: People1CheckIcon24Solid,
    },
    32: {
        regular: People1CheckIcon32Regular,
    },
    64: {
        regular: People1CheckIcon64Regular,
    },
};
export var People1CheckIcon = forwardRef('People1CheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
